import { List } from "@refinedev/antd";
import { CommentatorsList } from "./CommentatorsList";

export const CommentatorsPage = () => {
  return (
    <List
      title={""}
      resource={"commentators"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
    >
      <CommentatorsList />
    </List>
  );
};
